import { createAction } from '@reduxjs/toolkit'

export const changePage = (sliceName: string) => createAction<number>(`${sliceName}/changePage`)
export const changeLimit = (sliceName: string) => createAction<number>(`${sliceName}/changeLimit`)
